/**
 * @generated SignedSource<<63cd517c2d3d8227d76fdc92bc08d975>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: nx generate-api-types
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type TermsAndConditionsInput = {
  accepted?: boolean | null | undefined;
  after?: string | null | undefined;
  before?: string | null | undefined;
  first?: number | null | undefined;
  last?: number | null | undefined;
  mandatory?: boolean | null | undefined;
};
export type TermsAndConditionsViewQuery$variables = {
  input?: TermsAndConditionsInput | null | undefined;
};
export type TermsAndConditionsViewQuery$data = {
  readonly termsAndConditions: {
    readonly edges: ReadonlyArray<{
      readonly node: {
        readonly __typename: "TermsAndConditions";
        readonly accepted: boolean;
        readonly id: string;
        readonly mandatory: boolean | null | undefined;
        readonly source: string | null | undefined;
        readonly title: string | null | undefined;
        readonly type: string | null | undefined;
        readonly version: string | null | undefined;
      } | null | undefined;
    } | null | undefined> | null | undefined;
  } | null | undefined;
};
export type TermsAndConditionsViewQuery = {
  response: TermsAndConditionsViewQuery$data;
  variables: TermsAndConditionsViewQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "TermsAndConditionsConnection",
    "kind": "LinkedField",
    "name": "termsAndConditions",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "TermsAndConditionsEdge",
        "kind": "LinkedField",
        "name": "edges",
        "plural": true,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "TermsAndConditions",
            "kind": "LinkedField",
            "name": "node",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "id",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "type",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "title",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "version",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "source",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "accepted",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "mandatory",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "__typename",
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "TermsAndConditionsViewQuery",
    "selections": (v1/*: any*/),
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "TermsAndConditionsViewQuery",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "a552e2a813f07b72e908556109b4297f",
    "id": null,
    "metadata": {},
    "name": "TermsAndConditionsViewQuery",
    "operationKind": "query",
    "text": "query TermsAndConditionsViewQuery(\n  $input: TermsAndConditionsInput\n) {\n  termsAndConditions(input: $input) {\n    edges {\n      node {\n        id\n        type\n        title\n        version\n        source\n        accepted\n        mandatory\n        __typename\n      }\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "dcfe179ae71905092a9774faa1d4d429";

export default node;
